import $ from 'jquery';
import { createNewTemplate } from '~loader/loader-api';

export const createNewTemplateClickHandler = async (event) => {
  event.preventDefault();
  event.stopPropagation();

  const templateCategoryId = $(event.currentTarget).data(
    'giotto-create-template-category-id'
  );

  await createNewTemplate(templateCategoryId);
};
